export enum MessageType {
  TEXT = 'TEXT',
}

export enum StageKey {
  Outreach = 'outreach',
  InProgram = 'in-program',
}
